export default "__VITE_ASSET__335a839c__"